import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=7b7c046f&scoped=true&"
import script from "./ContactDetails.vue?vue&type=script&lang=js&"
export * from "./ContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=7b7c046f&prod&scoped=true&lang=scss&"
import style1 from "./ContactDetails.vue?vue&type=style&index=1&id=7b7c046f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7c046f",
  null
  
)

export default component.exports